import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTenantQualifications = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.6667 8.33464V5.66797C16.6667 4.26784 16.6667 3.56777 16.3942 3.03299C16.1545 2.56259 15.7721 2.18014 15.3017 1.94045C14.7669 1.66797 14.0668 1.66797 12.6667 1.66797H7.33334C5.93321 1.66797 5.23315 1.66797 4.69837 1.94045C4.22796 2.18014 3.84551 2.56259 3.60583 3.03299C3.33334 3.56777 3.33334 4.26784 3.33334 5.66797V14.3346C3.33334 15.7348 3.33334 16.4348 3.60583 16.9696C3.84551 17.44 4.22796 17.8225 4.69837 18.0622C5.23315 18.3346 5.93321 18.3346 7.33334 18.3346H10M10.4167 9.16797H6.66668M7.50001 12.5013H6.66668M13.3333 5.83464H6.66668M14.1644 12.3601C13.4979 11.6026 12.3866 11.3989 11.5516 12.0925C10.7166 12.7861 10.599 13.9459 11.2547 14.7662C11.9105 15.5866 14.1644 17.5013 14.1644 17.5013C14.1644 17.5013 16.4183 15.5866 17.074 14.7662C17.7298 13.9459 17.6266 12.7789 16.7772 12.0925C15.9278 11.4062 14.8308 11.6026 14.1644 12.3601Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTenantQualifications;
